import { jsx as _jsx } from "react/jsx-runtime";
import { useScreenWidth } from "../hooks/useScreenWidth.js";
import { Modal } from "../modal/Modal.js";
import { ModalOpenButton } from "../modal/ModalOpenButton.js";
import { PopoverOpenButton } from "./PopoverOpenButton.js";
export function PopoverWithModalOnMobile({ ref, title, content, children, ...props }) {
    const { isMinTablet } = useScreenWidth();
    return isMinTablet ? (_jsx(PopoverOpenButton, { content: content, children: children, ...props })) : (_jsx(ModalOpenButton, { Modal: FullscreenOnMobileModal, modalProps: {
            title,
            content,
        }, children: children }));
}
const FullscreenOnMobileModal = ({ title, handleClose, content, }) => {
    return (_jsx(Modal, { title: title, handleClose: handleClose, dialogProps: { fullScreen: true }, children: content }));
};
//# sourceMappingURL=PopoverWithModalOnMobile.js.map